import React from 'react';
import colors from '../../theme/colors';
import CommonButton from '../../components/common/CommonButton';

const UnderMaintenance = () => {
  return (
    <>
      <style>{`
        @keyframes floatY {
          0%, 100% { transform: translateY(0px); }
          50%       { transform: translateY(-12px); }
        }
        @keyframes spinSlow {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
        @keyframes spinReverse {
          from { transform: rotate(0deg); }
          to   { transform: rotate(-360deg); }
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50%       { opacity: 0.6; transform: scale(0.92); }
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes blobDrift {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33%       { transform: translate(30px, -20px) scale(1.05); }
          66%       { transform: translate(-20px, 15px) scale(0.97); }
        }
        .um-fade1 { animation: fadeInUp 0.6s ease both; }
        .um-fade2 { animation: fadeInUp 0.6s 0.15s ease both; }
        .um-fade3 { animation: fadeInUp 0.6s 0.3s ease both; }
        .um-fade4 { animation: fadeInUp 0.6s 0.45s ease both; }
        .um-retry-btn:hover { opacity: 0.88 !important; }
      `}</style>

      <div style={{
        minHeight: '100vh',
        width: '100%',
        background: 'var(--bg-splash)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px 16px',
        boxSizing: 'border-box',
        position: 'relative',
        overflow: 'hidden',
      }}>

        {/* Background decorative blobs */}
        <div style={{
          position: 'absolute', top: '-80px', right: '-80px',
          width: 320, height: 320, borderRadius: '50%',
          background: 'var(--blob-primary)',
          animation: 'blobDrift 8s ease-in-out infinite',
          pointerEvents: 'none',
        }} />
        <div style={{
          position: 'absolute', bottom: '-60px', left: '-60px',
          width: 280, height: 280, borderRadius: '50%',
          background: 'var(--blob-secondary)',
          animation: 'blobDrift 10s 2s ease-in-out infinite',
          pointerEvents: 'none',
        }} />
        <div style={{
          position: 'absolute', top: '40%', left: '5%',
          width: 160, height: 160, borderRadius: '50%',
          background: 'var(--blob-primary-sm)',
          animation: 'blobDrift 12s 1s ease-in-out infinite',
          pointerEvents: 'none',
        }} />

        {/* Card */}
        <div style={{
          maxWidth: 520,
          width: '100%',
          background: 'var(--bg-glass)',
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
          borderRadius: 20,
          // border: '1px solid rgba(147,51,234,0.12)',
          // boxShadow: '0 8px 40px rgba(147,51,234,0.1), 0 2px 12px rgba(0,0,0,0.06)',
          padding: '48px 40px 40px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          boxSizing: 'border-box',
        }}>

          {/* Illustration */}
          <div className="um-fade1" style={{ marginBottom: 24 }}>
            <img
              src="/assets/images/Under_construction.svg"
              alt="Under Maintenance"
              style={{
                width: '100%',
                maxWidth: 320,
                height: 'auto',
                maxHeight: '38vh',
                objectFit: 'contain',
                pointerEvents: 'none',
                mixBlendMode: 'multiply',
                animation: 'floatY 3.5s ease-in-out infinite',
              }}
            />
          </div>

          {/* "Back soon" badge */}
          <div className="um-fade2" style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            background: 'var(--bg-badge-brand)',
            border: '1px solid var(--border-badge-brand)',
            borderRadius: 99,
            padding: '5px 14px',
            marginBottom: 20,
          }}>
            <span style={{
              width: 7, height: 7, borderRadius: '50%',
              background: colors.themeColor,
              animation: 'pulse 1.8s ease-in-out infinite',
              display: 'inline-block',
            }} />
            <span style={{
              fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
              fontSize: 12,
              background: `linear-gradient(90deg, ${colors.themeColor}, ${colors.blueColor})`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              letterSpacing: 0.4,
            }}>
              WE'LL BE BACK SOON
            </span>
          </div>

          {/* Title */}
          <h1 className="um-fade2" style={{
            fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
            fontSize: 26,
            margin: '0 0 12px',
            background: `linear-gradient(90deg, ${colors.mainColor}, ${colors.themeColor})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            lineHeight: 1.3,
          }}>
            Under Maintenance
          </h1>

          {/* Description */}
          <p className="um-fade3" style={{
            fontFamily: 'PlusJakartaSans-Regular, sans-serif',
            fontSize: 15,
            color: colors.subTextColor,
            lineHeight: 1.7,
            margin: '0 0 28px',
            maxWidth: 380,
          }}>
            We're upgrading our systems to give you a better experience.
            This won't take long — please check back in a few minutes.
          </p>

          {/* Retry button */}
          <div className="um-fade4" style={{ width: '100%' }}>
            <CommonButton
              title="Try Again"
              icon="solar:refresh-bold"
              iconPosition="left"
              onClick={() => window.location.reload()}
              width="100%"
              height={48}
              style={{ margin: 0, borderRadius: 14 }}
            />
          </div>

        </div>
      </div>
    </>
  );
};

export default UnderMaintenance;
